import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { applyBrowserClasses } from './browser-detection'

// Apply browser detection for CSS fixes
applyBrowserClasses()

createApp(App).mount('#app')
